import { render, staticRenderFns } from "./IllnessBarChart.vue?vue&type=template&id=5a5944fe&"
import script from "./IllnessBarChart.vue?vue&type=script&lang=js&"
export * from "./IllnessBarChart.vue?vue&type=script&lang=js&"
import style0 from "./IllnessBarChart.vue?vue&type=style&index=0&id=5a5944fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports